// Tipos y estados de la agenda interna — adaptados al negocio real de BBTS
// (somos el software, no una cuadrilla de campo): llamadas de venta, demos,
// instalaciones/configuraciones de software, soporte, renovaciones de
// hosting y seguimiento. Nada de despacho de emergencia ni inspecciones de
// propiedad — eso es de puro_clean, un negocio distinto.
export const SCHEDULE_TYPE_STYLES = {
  sales_call: { label: 'Llamada de ventas', chip: 'bg-sky-100 text-sky-700', hex: '#0ea5e9' },
  demo: { label: 'Demostración', chip: 'bg-violet-100 text-violet-700', hex: '#8b5cf6' },
  installation: { label: 'Instalación / Configuración', chip: 'bg-amber-100 text-amber-700', hex: '#f59e0b' },
  support: { label: 'Soporte', chip: 'bg-rose-100 text-rose-700', hex: '#f43f5e' },
  meeting: { label: 'Reunión', chip: 'bg-slate-100 text-slate-700', hex: '#64748b' },
  hosting_renewal: { label: 'Renovación de hosting', chip: 'bg-emerald-100 text-emerald-700', hex: '#10b981' },
  follow_up: { label: 'Seguimiento', chip: 'bg-orange-100 text-orange-700', hex: '#ff4400' },
  other: { label: 'Otro', chip: 'bg-gray-100 text-gray-700', hex: '#9ca3af' },
};

export const SCHEDULE_STATUS_STYLES = {
  scheduled: { label: 'Programada', chip: 'bg-slate-100 text-slate-700' },
  confirmed: { label: 'Confirmada', chip: 'bg-sky-100 text-sky-700' },
  completed: { label: 'Completada', chip: 'bg-emerald-100 text-emerald-700' },
  cancelled: { label: 'Cancelada', chip: 'bg-rose-100 text-rose-700' },
};

export const getScheduleTypeMeta = (type) => SCHEDULE_TYPE_STYLES[type] || SCHEDULE_TYPE_STYLES.other;
export const getScheduleStatusMeta = (status) => SCHEDULE_STATUS_STYLES[status] || SCHEDULE_STATUS_STYLES.scheduled;

export const toDisplayDateTime = (date) => {
  if (!date) return 'Sin fecha';
  return date.toLocaleString('es-PR', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Puerto_Rico',
  });
};

// Dos eventos chocan si comparten al menos un empleado asignado y sus
// rangos de tiempo se solapan. Con 2 empleados manejando todo, un choque de
// agenda es un problema real, no un detalle cosmético.
export const detectScheduleConflicts = (draft, events, { excludeId } = {}) => {
  if (!draft?.startAt || !draft?.endAt || !draft?.assignedTo?.length) return [];
  const start = draft.startAt.getTime();
  const end = draft.endAt.getTime();
  return events.filter((ev) => {
    if (excludeId && ev.id === excludeId) return false;
    if (ev.status === 'cancelled') return false;
    if (!ev.assignedTo?.some((uid) => draft.assignedTo.includes(uid))) return false;
    if (!ev.startAt || !ev.endAt) return false;
    return start < ev.endAt.getTime() && end > ev.startAt.getTime();
  });
};
